import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';

// Widget de chat de tawk.to; solo se carga si el entorno define tawkToUrl
@Injectable({
  providedIn: 'root'
})
export class TawkToService {
  private _document = inject(DOCUMENT);

  public init(): void {
    const url = environment.tawkToUrl;
    if (!url) return;

    const ventana = window as unknown as { Tawk_API?: object; Tawk_LoadStart?: Date };
    ventana.Tawk_API = ventana.Tawk_API || {};
    ventana.Tawk_LoadStart = new Date();

    const script = this._document.createElement('script');
    script.async = true;
    script.src = url;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    this._document.body.appendChild(script);
  }
}
